import { useTranslation } from "react-i18next";

import { Accordion, Checkbox } from "@aviary";
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@shared/locales/i18n";

import type { Filter } from "../../CatalogSearch";
import { FilterTitle } from "../shared/FilterTitle/FilterTitle";

interface Props {
  isBold?: boolean;
  isCyberMondayEnabled?: boolean;
  isDrawer?: boolean;
}

const CurrentOffers = ({ isBold, isDrawer = false, isCyberMondayEnabled = false }: Props) => {
  const { t } = useTranslation();
  const { activeFilters, setActiveFilters } = useCatalogSearch();
  const { isUnauthenticated } = useSharedGlobalConfig();

  if (isUnauthenticated || isDrawer || !isCyberMondayEnabled) return null;

  const onSaleFilter: Filter = {
    id: "onSale",
    name: t(l.sharedCatalog.filter.CyberMonday),
    category: "More",
  };

  const isOnSaleActive = (): boolean =>
    activeFilters.some(activeFilter => activeFilter.id === onSaleFilter.id);

  const handleOnSaleSelect = () => {
    const distanceFromTop = window?.scrollY;
    if (isOnSaleActive()) {
      setActiveFilters(activeFilters.filter(activeFilter => activeFilter.id !== onSaleFilter.id));
    } else {
      setActiveFilters([...activeFilters, onSaleFilter]);
    }
    requestAnimationFrame?.(() => window?.scrollTo(0, distanceFromTop));
  };

  return (
    <Accordion
      coreTriggerContent={
        <FilterTitle
          title={t(l.sharedCatalog.filter.CurrentOffers)}
          count={Number(isOnSaleActive())}
          isSecondaryWeight={isBold}
          isBadge
        />
      }
      isDefaultExpanded
    >
      <Checkbox
        isFullWidth
        id="catalog-on-sale-checkbox"
        checked={isOnSaleActive()}
        onChange={() => handleOnSaleSelect()}
      >
        {t(l.sharedCatalog.filter.CyberMondaySale)}
      </Checkbox>
    </Accordion>
  );
};

export { CurrentOffers };
